module.exports = __webpack_public_path__ + "static/img/pad8.2b799d9c.png";